module.exports = __webpack_public_path__ + "img/login-icon.89da9447.png";